import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source", "button"]
  static values = { text: String }

  connect() {
    // Check if clipboard API is available
    if (!navigator.clipboard) {
      console.warn("Clipboard API not available")
      return
    }
  }

  copy(event) {
    event.preventDefault()
    
    let textToCopy
    
    // Get text from target, value, or data attribute
    if (this.hasSourceTarget) {
      textToCopy = this.sourceTarget.value || this.sourceTarget.textContent
    } else if (this.hasTextValue) {
      textToCopy = this.textValue
    } else if (event.currentTarget.dataset.clipboardText) {
      textToCopy = event.currentTarget.dataset.clipboardText
    } else {
      console.error("No text to copy found")
      return
    }

    navigator.clipboard.writeText(textToCopy).then(() => {
      this.showSuccess(event.currentTarget)
    }).catch(err => {
      console.error('Failed to copy text: ', err)
      this.showError(event.currentTarget)
    })
  }

  showSuccess(button) {
    const originalText = button.textContent
    button.textContent = "Copié !"
    button.classList.add("bg-green-600")
    button.classList.remove("bg-blue-600")
    
    setTimeout(() => {
      button.textContent = originalText
      button.classList.remove("bg-green-600")
      button.classList.add("bg-blue-600")
    }, 2000)
  }

  showError(button) {
    const originalText = button.textContent
    button.textContent = "Erreur"
    button.classList.add("bg-red-600")
    button.classList.remove("bg-blue-600")
    
    setTimeout(() => {
      button.textContent = originalText
      button.classList.remove("bg-red-600")
      button.classList.add("bg-blue-600")
    }, 2000)
  }
}